var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EDE8F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1024_3626)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3281 23.7453C26.8945 22.9984 26.25 20.8852 26.25 18.125C26.25 14.6732 23.4518 11.875 20 11.875C16.5482 11.875 13.75 14.6732 13.75 18.125C13.75 20.8859 13.1047 22.9984 12.6711 23.7453C12.4457 24.1318 12.4441 24.6092 12.6668 24.9973C12.8895 25.3853 13.3026 25.6247 13.75 25.625H16.9383C17.2356 27.0796 18.5153 28.1243 20 28.1243C21.4847 28.1243 22.7644 27.0796 23.0617 25.625H26.25C26.6972 25.6244 27.1101 25.3849 27.3326 24.9969C27.5551 24.609 27.5534 24.1317 27.3281 23.7453ZM20 26.875C19.2056 26.8748 18.4976 26.3739 18.2328 25.625H21.7672C21.5024 26.3739 20.7944 26.8748 20 26.875ZM13.75 24.375C14.3516 23.3406 15 20.9438 15 18.125C15 15.3636 17.2386 13.125 20 13.125C22.7614 13.125 25 15.3636 25 18.125C25 20.9414 25.6469 23.3383 26.25 24.375H13.75Z",
    fill: "#140D1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1024_3626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.1b51b61caa725d71ea90c52916d96fe1.svg";
export { ForwardRef as ReactComponent };